import { API } from 'aws-amplify';

import { ActionTree, ActionContext } from 'vuex';
import { RootState } from '../types';
import { InspectorsState } from './types';

import { Inspector } from '@/models';
import _ from 'lodash';
export const actions: ActionTree<InspectorsState, RootState> = {

	/**
	 * Get all Inspectors
	 * 
	 * @param {InspectorsState} store
	 * @param filters
	 * @returns All Inspectors
	 */
	async getInspectors(store: ActionContext<InspectorsState, any>): Promise<Inspector[]> {
		store.commit('app/addRequest', 'getInspectors', { root: true });

		return API.get('RestAPI', `/inspectors`, {})
			.then((response) => response.map((x: Partial<Inspector>) => new Inspector(x)))
			.then((Inspector: Inspector[]) => {
				store.commit('setInspectors', Inspector);
				return Inspector;
			})
			.finally(() => store.commit('app/removeRequest', 'getInspectors', { root: true }));
	},

	/**
	 * Get one Inspector
	 * 
	 * @param {InspectorsState} store 
	 * @param id 
	 * @returns individual Inspector
	 */
	async getInspector(store: ActionContext<InspectorsState, any>, id) {
		// New Inspector
		if (id === 'new') {
			const inspector = new Inspector();
			store.commit('setCurrent', inspector);
			return inspector;
		}
		store.commit('app/addRequest', 'getInspector', { root: true });

		return API.get('RestAPI', `/inspectors/${id}`, null)
			.then((response) => new Inspector(response))
			.then((Inspector: Inspector) => {
				store.commit('setCurrent', Inspector);
				return Inspector;
			})
			.finally(() => store.commit('app/removeRequest', 'getInspector', { root: true }));
	},

	/**
   * Add Inspector
   * 
   * @param {InspectorsState} store 
   * @param Inspector Inspector
   */
	async addInspectors(store: ActionContext<InspectorsState, any>, inspector: Inspector): Promise<void> {
		store.commit('app/addRequest', 'addInspector', { root: true });
		return API.post('RestAPI', '/inspectors', { body: inspector.toJSON() })
			.then((data) => new Inspector(data))
			.then((Inspectorfromserver: Inspector) => {
				store.commit('resetUnsavedChanges');
			})
			.finally(() => store.commit('app/removeRequest', 'addInspector', { root: true }));
	},

	/**
   * Delete Inspector
   * 
   * @param {InspectorsState} store 
   * @param Inspector Inspector
   */
	async deleteInspectors(store: ActionContext<InspectorsState, any>, Inspector: Inspector): Promise<void> {
		store.commit('app/addRequest', 'deleteInspector', { root: true });
		return API.del('RestAPI', `/inspectors/${Inspector.id}`, {})
			.then(() => {
				store.commit('resetUnsavedChanges');
				store.commit('setInspectors', _.remove(store.state.list, (c: Inspector) => c.id != Inspector.id));
			})
			.finally(() => store.commit('app/removeRequest', 'deleteInspector', { root: true }));
	},


	/**
   * Update given Inspector details
   * 
   * @param {InspectorsState} store 
   * @param Inspector Inspector
   */
	async updateInspectors(store: ActionContext<InspectorsState, any>, inspector: Inspector): Promise<void> {
		store.commit('app/addRequest', 'updateInspector', { root: true });
		return API.put('RestAPI', `/inspectors/${inspector.id}`, { body: inspector.toJSON() })
			.then((data) => new Inspector(data))
			.then((Inspector: Inspector) => {
				store.commit('setCurrent', Inspector);
				store.commit('resetUnsavedChanges');
			})
			.finally(() => store.commit('app/removeRequest', 'updateInspector', { root: true }));
	},

	/**
   * Sets any deep Inspector inspector and increments the "unsaved changes" count
   * @param store
   * @param data
   */
	setInspectorsDeep(store: ActionContext<InspectorsState, any>, data): void {
		store.commit('setInspectorsDeep', data);
		store.commit('addUnsavedChange');
	},

	/**
 * Set the page for the Reports query
 *
 * @param store
 * @param data
 */
	resetCurrentPage(store: ActionContext<InspectorsState, any>): void {
		store.commit('setCurrentPage', 1);
	},
}
